<template><div><h1 id="ereignisse-zu-person" tabindex="-1"><a class="header-anchor" href="#ereignisse-zu-person"><span>Ereignisse zu Person</span></a></h1>
<p>Ereignisse zu Person — Anzeige und Erfassung von Ereignissen zu Person</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In diesem Frame ist die Kundengeschichte abgebildet welche in der Regel durch Versände, Zahlungen, Vedankungen, etc. automatisch nachgeführt wird. Bei Bedarf kann aber auch manuell ein Ereigniseintrag vorgenommen werden.</p>
<p>Pfad: <code v-pre>Personen → Ereignisse</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Datum</dt>
<dd>Datum des Ereignisses</dd>
<dt>Bezug</dt>
<dd>Bezug des Eintrags. Ereigniseintrag einer anderen Person die in Beziehung mit dieser Person steht.</dd>
<dt>Status</dt>
<dd>Status des Ereignisses gemäss Tabelle <a class="link" href="ft.refdata.ereigstat.html" title="Ereignisstatus">Ereignis-Stati</a></dd>
<dt>Ereignis</dt>
<dd>Ereignis (Darstellung ist parametrisierbar über den Systemparameter AdrEreigBez)</dd>
<dt>Response</dt>
<dd>Betrag in CHF (nur bei Response-Ereignissen)</dd>
<dt>Person</dt>
<dd>Name/Firma der Person wenn es ein Ereignis einer anderen Person ist (siehe Feld Bezug).</dd>
<dt>Kanal</dt>
<dd>Kommunikationskanal, z.B. bei postalischen Versänden &quot;Post&quot; oder bei Responses die Zahlungsart (ESR, Kreditkarte, etc.)</dd>
<dt>Adresse</dt>
<dd>Verwendete Adresse der Person für das Ereignis.</dd>
<dt>A</dt>
<dd>Zeigt durch ein Büroklammer-Symbol an, wenn ein Attachment angefügt ist.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<dl>
<dt>Drucken...</dt>
<dd>Druckt die Person aus.</dd>
<dt>Ereignis-Refusé erfassen...</dt>
<dd>Erfasst ein Refusé-Ereignis zu einem Initial-Ereignis. Das Initial-Ereignis muss vorgängig selektiert sein.</dd>
<dt>Ereignis-Response erfassen...</dt>
<dd>Erfasst ein Response-Ereignis zu einem Initial-Ereignis. Das Initial-Ereignis muss vorgängig selektiert sein.</dd>
</dl>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.ereignisse.html" title="Personenereignisse">Ereignisse</RouteLink></p>
</div></template>


